import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { StatusBoardContainer, DataTableContainer, EditBox, GeneralInformationContainer } from './StatusComponentBoard.css.js';
import StatusBoard from './StatusBoard';
import ColumnSetPopup from './ColumnSetPopup';
import columnData from './columnData';

const StatusComponentBoard = () => {
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [boardData, setBoardData] = useState(null);
  const theme = useSelector((state) => state.mainSetting.board.theme);
  const columnSetting = useSelector((state) => state.mainSetting.board.column);

  const gasLog = useSelector((store) => store.gasLog);
  const noneModuleTerm = useSelector((store) => store.settings).setting.noneModuleTerm;

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (gasLog.status === 'SUCCESS') {
      const dangerStatusModuleIndex = gasLog.gas.findIndex((gas) => gas.status === 'danger' || gas.status === 'warning');

      if (dangerStatusModuleIndex === -1) {
        dispatch({ type: 'ALERT_OFF' });
      }

      setBoardData(gasLog.gas);
    }
  }, [noneModuleTerm, gasLog]);

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!boardData) {
    return <StatusBoardContainer></StatusBoardContainer>;
  }

  return (
    <StatusBoardContainer theme={theme}>
      <DataTableContainer theme={theme} dataLength={boardData.dataLength}>
        <EditBox>
          <select
            onChange={({ target }) => {
              dispatch({ type: 'BOARD_THEME_SET', data: target.value });
            }}
            defaultValue={theme}
          >
            <option value="normal">기본형</option>
            <option value="excel">엑셀형</option>
          </select>
          <ColumnSetPopup />
        </EditBox>
        <div className="table-box">
          <table>
            <colgroup>
              {columnSetting.map((column) => {
                return <col width={columnData(0)[column].colWidth} />;
              })}
            </colgroup>
            <thead>
              <tr>
                {columnSetting.map((column) => {
                  if (column === 'areaNo' || (column === 'areaNm' && columnSetting.indexOf('areaNo') === -1)) {
                    return <th colSpan={columnSetting.filter((x) => x === 'areaNo' || x === 'areaNm').length}>Location</th>;
                  } else if (column === 'areaNm' && columnSetting.indexOf('areaNo') !== -1) {
                    return '';
                  }

                  return columnData(0)[column].th;
                })}
              </tr>
              <tr>
                {columnSetting.indexOf('areaNo') !== -1 && columnData(0)['areaNo'].th}
                {columnSetting.indexOf('areaNm') !== -1 && columnData(0)['areaNm'].th}
              </tr>
            </thead>
            <tbody>
              {boardData.map((data, i) => {
                return <StatusBoard key={`${data.title}_${data.moduleIdx}`} index={i} {...data} />;
              })}
            </tbody>
          </table>
        </div>
      </DataTableContainer>
      <GeneralInformationContainer theme={theme}>
        <div className="information-title">
          <div className="module-count">운용 중 감지기 대수</div>
          <div className="status">상태종합</div>
        </div>
        <div className="information-data">
          <div className="module-count">{boardData.length} 대</div>
          <div className="status blue">정상 : {boardData.length > 0 && boardData.filter((x) => x.status === 'blue').length} 대</div>
          <div className="status danger">위험 : {boardData.length > 0 && boardData.filter((x) => x.status === 'danger').length} 대</div>
          <div className="status warning">경고 : {boardData.length > 0 && boardData.filter((x) => x.status === 'warning').length} 대</div>
          <div className="status none">미수신 : {boardData.length > 0 && boardData.filter((x) => x.status === 'none').length} 대</div>
        </div>
      </GeneralInformationContainer>
    </StatusBoardContainer>
  );
};

export default StatusComponentBoard;
